import moment from 'moment';
import { useSelector } from 'react-redux';
import Exchange from '../../../models/Exchange';
import Utils from '../../../utils/utils';
import Analytics from '../../../utils/analytics';
export var useCancelButton = function (_a) {
    var conversation = _a.conversation, user = _a.user;
    var accessToken = useSelector(function (state) { return state.auth.accessToken; });
    var redirectToCancelPage = function () {
        var eventData = {
            funnel_name: 'exchange_cancellation',
            funnel_step: 'exchange_cancellation_warning',
            collection: user.isCollection()
        };
        Analytics.trackGTM('funnel_start', { event_data: eventData }, function () {
            window.location.assign("".concat(Utils.getUrlLocalePrefix(), "/conversations/").concat(conversation.id, "/cancel"));
        });
    };
    var canCancel = function () {
        var asGuestExchange = conversation.getExchangeAsGuest();
        var asHostExchange = conversation.getExchangeAsHost();
        var lowerStatusExchange = conversation.getExchangeWithLowerStatus();
        var exchangeIsMutual = conversation.isMutual();
        if (exchangeIsMutual) {
            return (lowerStatusExchange.get('status') > Exchange.STATUS_PREAPPROVED &&
                !lowerStatusExchange.isCanceled() &&
                moment(asHostExchange.get('start_on')).isSameOrAfter(moment().format('YYYY-MM-DD')) &&
                moment(asGuestExchange.get('start_on')).isSameOrAfter(moment().format('YYYY-MM-DD')));
        }
        else {
            return (asHostExchange === null || asHostExchange === void 0 ? void 0 : asHostExchange.isCancelable()) || (asGuestExchange === null || asGuestExchange === void 0 ? void 0 : asGuestExchange.isCancelable());
        }
    };
    var onClickCancelButton = function () { return redirectToCancelPage(); };
    return {
        canCancel: canCancel,
        onClickCancelButton: onClickCancelButton
    };
};
